export const featureName = 'giftCard';
export const GIFT_CARD_PAGE_SIZE = 10;

export interface IGiftCardListResponse {
  totalElements: number;
  totalPages: number;
  pageable: {
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  content: IGiftCardType[];
}

export interface IGiftCardType {
  giftCardId: string;
  giftNumber: string;
  customerName: string;
  customerPhone: string | null;
  amount: number;
  redeemAmount: number;
  issuedDate: string;
  lastUsedDate: string;
  expiredDate: string;
  sourceType: string;
  totalReset: number;
  balanceAmount: number;
  tracking: IGiftCardTracking[];
}
export interface IGiftCardTracking {
  id: string;
  ticketNumber: number;
  createdDate: string;
  amount: number;
  action: string;
  customerName: string;
  customerPhone: string;
}

export interface GetGiftCardListParams {
  page?: number;
  size?: number;
  keySearch?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}

export interface CreateGiftCardBody {
  amount: number;
  customerId?: string;
  expirationDate: string;
  status: 'In Store' | 'Online';
}

export interface UpdateGiftCardBody {
  id: string;
  amount: number;
  expirationDate: string;
}

export interface IGiftCardSummary {
  totalGiftCard: number;
  totalAmount: number;
  totalRedeem: number;
  totalSellOnline: number;
  totalSellStore: number;
}

export interface IAddManUalGiftCardBody {
  customerId: string;
  amount: number;
  giftCode: string;
  usedAmount?: number;
  note: string;
  expiredDate: string;
}
